module.exports = __webpack_public_path__ + "img/logo1.c70fc584.png";